// @react/hooks/useNotificationsChannel.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { notificationsChannelStore } from '@core/stores';

/**
 * React hook for NotificationChannel operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useNotificationsChannel } from '@react/hooks';
 *
 * const NotificationChannelList = observer(() => {
 *   const store = useNotificationsChannel();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useNotificationsChannel() {
  return notificationsChannelStore;
}
